/** @jsx isolateComponent */
import { isolateComponent } from '@zapier/style-encapsulation';
import { css } from '@emotion/react';
import { Link, Text, TypographyName } from '../../../index';

const Styles = {
  ctaDisclaimer: css`
    margin: 10px 0;
  `,
};
type DisclaimerProps = {
  color: 'primary' | 'secondary';
  termsLink?: string;
  privacyLink?: string;
  textType?: TypographyName;
};

/**
 * Internal component for disclaimer which is to be displayed along with Subscription
 * form in page builder
 */
export const DisclaimerText = ({
  color = 'primary',
  termsLink = 'https://zapier.com/tos',
  textType = 'paragraph3',
  privacyLink = 'https://zapier.com/privacy',
}: DisclaimerProps) => {
  const textColor = color === 'primary' ? 'neutral700' : 'neutral100';

  return (
    <div css={Styles.ctaDisclaimer}>
      <Text tag="p" type={textType} color={textColor}>
        By signing up, you agree to Zapier’s{' '}
        <Link href={termsLink} color={color}>
          Terms of Service
        </Link>{' '}
        and{' '}
        <Link href={privacyLink} color={color}>
          Privacy Policy
        </Link>
        .
      </Text>
    </div>
  );
};
